import qs from 'qs'
import axios from './../../index'

/**
 * @description 医保专区
 * @author txw
 * @date 2020-05-23
 * @export
 */
export function loadMedicareData (params) {
  return axios.post('/product/medicare', qs.stringify(params))
}
